import React, { useEffect } from "react";
import upload from "../../assets/./images/upload.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getDownloadPurchaseReport,
  getDownloadSalesReport,
  getDownloadVatReport,
} from "../../../redux/service/action";
import * as XLSX from "xlsx";

const VatReportExport = ({ params }) => {
  const dispatch = useDispatch();
  const downloadReport = useSelector(
    (state) => state?.reusableSlice?.getVatReportdata
  );

  useEffect(() => {
    if (params) {
      const updatedParams = { ...params, download_csv: true };
      dispatch(getDownloadVatReport(updatedParams));
    }
  }, [params, dispatch]);

  const handleExport = () => {
    if (!downloadReport || typeof downloadReport !== "string") {
      return;
    }

    const rows = downloadReport
      .split("\n")
      .map((row) => row.trim())
      .filter((row) => row !== "");

    if (rows.length < 2) {
      console.error("Invalid data format");
      return;
    }

    const headers = rows[0].split(",");
    const data = rows.slice(1).map((row) => {
      const cleanedRow = row.replace(/[\r\n]/g, "").trim();
      const fields = cleanedRow.split(",");

      return {
        [headers[0]]: fields[0],
        [headers[1]]: fields[1],
        [headers[2]]: fields[2],
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "VatReport");
    XLSX.writeFile(workbook, "VatReport.xlsx");
  };

  return (
    <div>
      <button
        className="add-btn btn corner-btn"
        type="button"
        onClick={handleExport}
      >
        <img src={upload} alt="" /> Export
      </button>
    </div>
  );
};

export default VatReportExport;
